import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../common/layout/layout.module'
import { ContactFormComponent } from './contact-form/contact-form.component'

import { ContactsRoutingModule } from './contacts-routing.module';
import { SharedModule } from '../../common/shared/shared.module';
import { ContactsListComponent } from './contacts-list/contacts-list.component';
import { ReactiveFormsModule } from '@angular/forms';

const declarations = [
    ContactsListComponent,
    ContactFormComponent,
];

@NgModule({
    declarations: [
        ...declarations,
    ],
    imports: [
        CommonModule,
        ContactsRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        LayoutModule
    ]
})
export class ContactsModule { }
